// extracted by mini-css-extract-plugin
module.exports = {"table_container":"table_container___12sDN","title_container":"title_container___1OIaA","title":"title___1WYXY","collection_detail_container":"collection_detail_container___t9Okl"};